import { render, staticRenderFns } from "./VersionOverlay.vue?vue&type=template&id=520dbe88&scoped=true"
import script from "./VersionOverlay.vue?vue&type=script&lang=js"
export * from "./VersionOverlay.vue?vue&type=script&lang=js"
import style0 from "./VersionOverlay.vue?vue&type=style&index=0&id=520dbe88&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520dbe88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('520dbe88')) {
      api.createRecord('520dbe88', component.options)
    } else {
      api.reload('520dbe88', component.options)
    }
    module.hot.accept("./VersionOverlay.vue?vue&type=template&id=520dbe88&scoped=true", function () {
      api.rerender('520dbe88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VersionOverlay.vue"
export default component.exports